import { QueryClient } from "react-query";

const taskTypesQueryKey = "getTaskTypes";

export const invalidateTaskTypes = (queryClient: QueryClient): Promise<void> =>
    queryClient.invalidateQueries(taskTypesQueryKey, { refetchInactive: true });
